<template>
  <tr class="bh-user-row">
    <td class="bh-user-col">
      <profile-preview-image
        :profileId="user.profileId"
        :uuid="user.uuid"
        :avatarClasses="['bh-user__avatar', 'avatar', 'rounded']"
        :avatarSize="48"
        :thumbnailUrl="user.thumbnailUrl"
      />
    </td>
    <td class="bh-user-col" colspan="2">
      <h4 @click="$emit('to-user', user.id)" class="bh-user__name">
        {{ user.firstName }} {{ user.lastName }}
      </h4>
      <span class="pr-2">{{ user.isActive ? 'Active' : 'Inactive' }}</span>
    </td>
    <td class="bh-user-col bh-user-col--full">
      <strong>{{ dictionaryBhUsersRoleIds[user.roleId] }}</strong>
    </td>
    <td class="bh-user-col">
      <span class="bhGray2--text text-nowrap">
        {{ user.creationDate | moment('MMMM Do, YYYY') }}
      </span>
    </td>
    <td class="bh-user-col" style="height: 100%;">
      <div class="d-flex align-center justify-end">
        <v-btn
          v-if="roleAllowedToSwitchAndManageOtherAccount"
          rounded
          color="accent"
          elevation="0"
          class="mr-2"
          @click="handleSwitchAccountNow"
        >
          <span>Switch now</span>
        </v-btn>
        <v-btn
          icon
          color="accent"
          elevation="0"
          @click="$emit('to-user', user.id)"
        >
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import VueRouter from 'vue-router'
import ProfilePreviewImage from '@/components/profile/ProfilePreviewImage.vue'
import Config from '@/config.json'
export default {
  components: { ProfilePreviewImage },
  name: 'BhUserTableRow',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('dictionariesStates', ['dictionaryBhUsersRoleIds']),
    ...mapGetters('userStates', ['getRolename', 'getProfileId']),
    roleAllowedToSwitchAndManageOtherAccount() {
      return (
        this.dictionaryBhUsersRoleIds[this.getRolename] ===
          this.dictionaryBhUsersRoleIds.Admin &&
        this.user.roleId !== this.dictionaryBhUsersRoleIds.Admin
      )
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('bhUsersStates', ['generateSurrogateAuthToken']),
    handleLoadStart() {
      this.isLoading = true
    },
    handleLoad() {
      this.isLoading = false
    },
    handleSwitchAccountNow() {
      this.generateSurrogateAuthToken({
        userProfileId: this.getProfileId,
        username: this.user.email,
      }).then(res => {
        localStorage.clear()
        if (res.token) {
          window.location.href = `${Config.VUE_APP_CAS_URL_SHORT}/login?token=${res.token}`
        }
      })
    },
  },
}
</script>

<style lang="scss">
.bh-user {
  &__name {
    // what about wrapping names?
    min-width: 150px;
    max-width: 200px;
    margin-bottom: 4px;
    cursor: pointer;

    // do we hant hover style?
    // &:hover {
    //   text-decoration: underline;
    // }
  }

  &__avatar {
    overflow: hidden;
    border-radius: 8px;
    width: 48px;
    height: 48px;
    .v-image {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  &-row {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.04);
    border-radius: $border-radius-root;

    &:hover {
      background: transparent !important;
    }
  }

  &-col {
    padding: 8px !important;
    border-bottom: 0 !important;
    background: $bh-white;

    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      font-size: 0.857rem;
      line-height: 1rem;
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
    }
    &--full {
      width: 100%;
    }
  }
}
</style>
